import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import {
  Card,
  Input,
  Select,
  Button,
  CardBody,
  CardFooter,
  SelectItem,
} from "@nextui-org/react"
import { MainContainer } from "../../components/index.js"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import { apiRoute, linksUrl } from "../../constants/enum.js"

function CreateMenuMaster() {
  
  const navigate = useNavigate() 
  
  const { selectedApp } = useSelector((state) => state.appMaster)
  
  const [errors, setErrors] = useState({})

  const [formData, setFormData] = useState({
    appId: selectedApp.AppId,
    menuParentId: null,
    menuName: "",
    level: "1",
  })

  

  const { data: menuParent = [] } = useFetchWithBody({
    url: apiRoute.menuMaster.read,
    queryKey: "MenuParent",
    inputData: {
      menuId: null,
      appId: selectedApp.AppId,
      option: 3,
    },
  })

  console.log(menuParent)

  const onClickPrevPage = () => {
    navigate(linksUrl.menuMaster.read)
  }

  const onSuccessTasks = () => {
    navigate(linksUrl.menuMaster.read)
  }
  const resetValues = () => {}

  const { isPending, mutate: addMenuMaster } = usePost({
    url: apiRoute.menuMaster.add,
    queryKey: "MenuMaster",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    const newErrors = {}
     // Validate AppId
    if (formData.appId.toString().trim() === "") {
      newErrors.appId = "App Id is required"
    }
    // Validate Menu Name
    if (formData.menuName.trim() === "") {
      newErrors.menuName = "Menu Name is required"
    }
    // Validate Level
    if (formData.level.trim() === "") {
      newErrors.level = "Level is required"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validateForm()) {
      // Perform form submission logic here

      let menuParentId = parseInt(formData.menuParentId)
      menuParentId =
        typeof menuParentId != "number" || isNaN(menuParentId)
          ? null
          : menuParentId

      addMenuMaster({
        data: {
          appId: formData.appId,
          menuParentId: typeof menuParentId !== "number" ? null : menuParentId,
          menuName: formData.menuName,
          level: formData.level,
        },
      })
    }
  } 

  const handleSelectMenuParent = (e) => {
    setFormData((prev) => ({
      ...prev,
      menuParentId: e.target.value,
    }))
  }

  return (
    <MainContainer
      breadcrumbs={["App Master", "Menu Master", "Add"]}
      pageName={"Add Menu"}
      prevPage={{ show: true, onClick: onClickPrevPage }}
      info={[["App", selectedApp.AppName]]}
    >
      <Card className="max-w-[600px]" shadow="none" classNames="p-0">
        <form onSubmit={handleSubmit}>
          <CardBody className="p-0">
            <div className="flex flex-col gap-4 mx-2">
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Select
                  label="Menu Parent"
                  placeholder="Select a Menu Parent"
                  className="max-w-xs"
                  onChange={handleSelectMenuParent}
                >
                  {menuParent?.map((row) => (
                    <SelectItem key={row?.MenuId} value={row?.MenuId}>
                      {row?.MenuName}
                    </SelectItem>
                  ))}
                </Select>
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  type="text"
                  label="Menu Name"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.menuName}
                  errorMessage={errors?.menuName}
                  name="menuName"
                  value={formData.menuName}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  type="text"
                  label="Level"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.level}
                  errorMessage={errors?.level}
                  name="level"
                  value={formData.level}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
              </div>
            </div>
          </CardBody>
          <CardFooter>
            <Button color="primary" type="submit" isLoading={isPending}>
              Add Menu
            </Button>
          </CardFooter>
        </form>
      </Card>
    </MainContainer>
  )
}

export default CreateMenuMaster
